module.exports = __webpack_public_path__ + "static/img/bcg_2.84d5399e.png";